'use client';

import { useState } from 'react';
import dynamic from 'next/dynamic';
import AuthDrawerSkeleton from '../auth-drawer-skeleton';
import type { AccountRegistrationDrawerProps } from './types';

// Re-export so sibling triggers (register-trade-account-trigger) keep their
// `import { REGISTRATION_DRAWER_ID } from '../registration-drawer'` working.
export { REGISTRATION_DRAWER_ID } from './constants';

// EWM-306: lazy-load the registration drawer body (react-hook-form + the full
// two-step form) so that weight only ships when a user actually opens the
// Register drawer — a once-per-lifetime path.
const RegistrationDrawerContent = dynamic(() => import('./components/registration-drawer-content'), {
  ssr: false,
  // widthClassName mirrors the content drawer's `w-screen! max-w-xl!` — keep in sync.
  loading: () => <AuthDrawerSkeleton headlineKey="auth.register-title" widthClassName="w-screen max-w-xl" />,
});

const AccountRegistrationDrawer = (props: AccountRegistrationDrawerProps) => {
  // Latch: the provider always renders this drawer (toggling isOpen), so a naive
  // dynamic() would fetch the chunk on page load. Render nothing until the first
  // open; once opened, stay mounted so the close animation plays and re-opens
  // need no second fetch.
  const [hasOpened, setHasOpened] = useState(false);
  if (props.isOpen && !hasOpened) setHasOpened(true);
  if (!hasOpened) return null;

  return <RegistrationDrawerContent {...props} />;
};

export default AccountRegistrationDrawer;
